import deviceMenu from '@js/common/deviceMenu.js';
import {
    aosInit,
} from '@js/common/aos.js';
import {
    headeraddClass,
    appendSVGBtn,
} from '@js/common/customFunctions.js';

deviceMenu();
aosInit();
headeraddClass();
/* Script on ready
------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('a, button, .btn').forEach(function(element) {
        // Determine which icon to use
        let iconId = null;

        if (
            element.classList.contains('btn') &&
			element.classList.contains('-whatsapp')
        ) {
            iconId = '#icon-whatsapp';
        } else if (element.classList.contains('btn')) {
            iconId = '#icon-arrow-right';
        }

        // If not a recognized button, skip
        if (!iconId) {
            return;
        }

        // ----- Ensure span wrapper for icons -----
        let iconsWrapper = element.querySelector('span.btn-icons');
        if (!iconsWrapper) {
            iconsWrapper = document.createElement('span');
            iconsWrapper.classList.add('btn-icons');
            element.appendChild(iconsWrapper);
        }

        // ----- Ensure PREPEND <i> -----
        let firstIcon = iconsWrapper.querySelector('i.icon.first');
        if (!firstIcon) {
            firstIcon = document.createElement('i');
            firstIcon.classList.add('icon', 'first');
            iconsWrapper.insertBefore(firstIcon, iconsWrapper.firstChild);
        }
        appendSVGBtn(firstIcon, iconId, '24', '24');

        // ----- Ensure APPEND <i> -----
        let lastIcon = iconsWrapper.querySelector('i.icon.last');
        if (!lastIcon) {
            lastIcon = document.createElement('i');
            lastIcon.classList.add('icon', 'last');
            iconsWrapper.appendChild(lastIcon);
        }
        appendSVGBtn(lastIcon, iconId, '24', '24');
    });

    // const disclaimerPopup = document.querySelector('.disclaimer-popup');

    // // Safety check
    // if (!disclaimerPopup) {
    //     return;
    // }

    // const popupClose = disclaimerPopup.querySelectorAll('.popup-close');

    // // Delay showing the popup
    // setTimeout(() => {
    //     disclaimerPopup.classList.add('is-show');
    //     document.body.classList.add('scroll-fixed');

    //     if (popupClose) {
    //         popupClose.forEach(popupEle => {
    //             popupEle.addEventListener('click', (e) => {
    //                 // Check if the clicked button is the "Accept" button
    //                 if (e.target.classList.contains('accept-disclaimer')) {
    //                     // Set cookie for 30 days
    //                     document.cookie = 'disclaimer_accepted=true; path=/; max-age=' + (30 * 24 * 60 * 60);
    //                 }

    //                 // Close the popup
    //                 disclaimerPopup.classList.remove('is-show');
    //                 document.body.classList.remove('scroll-fixed');
    //             });
    //         });
    //     }
    // }, 1200);

});

/* Use jQuery code Start */
(function($) {
    // Write code here

    $('.home-hero-section .scroll-top-next').on('click', function() {
        const nextSection = $(this).parents('.home-hero-section').next().offset().top;
        $('html, body').animate({
            scrollTop: nextSection - $('header.main-header').outerHeight(),
        },
        500,
        );
    });
})(jQuery);
/* Use jQuery code End */
